module.exports = __webpack_public_path__ + "img/doggy-package-2.small.a31dcb7d.webp";